import { isMobile } from "@/utils";
const baseSize = 16//  1rem等于20px 若修改需和.prostcssrc.js同步修改  布局直接用px会自动转成rem
// 设置 rem 函数
function setRem () {
  if(isMobile()) {
    const scale = document.documentElement.clientWidth / 375
    // 设置页面根节点字体大小
    document.documentElement.style.fontSize = (baseSize * Math.min(scale, 2)) + 'px'
  }

}
// 初始化
setRem()
// 改变窗口大小时重新设置 rem
window.onresize = function () {
  setRem()
}
